import { render, staticRenderFns } from "./create-report-type.vue?vue&type=template&id=6a535615&scoped=true"
import script from "./create-report-type.vue?vue&type=script&lang=js"
export * from "./create-report-type.vue?vue&type=script&lang=js"
import style0 from "./create-report-type.vue?vue&type=style&index=0&id=6a535615&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a535615",
  null
  
)

export default component.exports